<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: 'TicketsPage',
  components: {LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let data = ref({
      action:'add',
      title: null,
      caption: ''
    })

    function send_ticket() {

      if (!data.value.title){
        swals.Warning('لطفا موضوع تیکت خود را انتخاب کنید !')
        return false
      }

      if (data.value.caption.length < 4){
        swals.Warning('لطفا مشکل خود را شرح دهید !')
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'ticket' , true).then((res)=>{

        loading.value = false
        if (res.data.status === 'ok') {

          data.value.title = null
          data.value.caption = ''
          Swals.Done(res.data.event)

        } else {
          Swals.Fault('متاسفانه تیکت شما ثبت نشد!')
        }

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, send_ticket)
      })

    }

    return {
      loading,
      send_ticket,
      data,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">ثبت تیکت</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div class="p-body mt-2 animate__animated animate__fadeIn">
        <p class="font-5 mb-5 font-bold text-end p-body">
          انتخاب موضوع تیکت
        </p>

        <div class="d-flex justify-content-between w-100">
          <div @click="data.title = 'مشکل خاص در اپلیکیشن' " :class="data.title === 'مشکل خاص در اپلیکیشن' ? 'bg-color-light' : 'bg-white'"
               class="w-45 border-costom text-center shadow-KhA font-5 rounded-3 py-3 px-2">
            مشکل خاص در اپلیکیشن
          </div>

          <div @click="data.title = 'بروز مشکل در آگهی' " :class="data.title === 'بروز مشکل در آگهی' ? 'bg-color-light' : 'bg-white'"
               class="w-45 border-costom text-center font-5 shadow-KhA rounded-3 py-3 px-2">
            بروز مشکل در آگهی
          </div>
        </div>

        <br>

        <div class="d-flex justify-content-between w-100">
          <div @click="data.title = 'سایر موارد' " :class="data.title === 'سایر موارد' ? 'bg-color-light' : 'bg-white'"
               class="w-45 border-costom text-center shadow-KhA font-5 rounded-3 py-3 px-2">
            سایر موارد
          </div>

          <div @click="data.title = 'انتقاد و پیشنهاد' " :class="data.title === 'انتقاد و پیشنهاد' ? 'bg-color-light' : 'bg-white'"
               class="w-45 border-costom text-center shadow-KhA font-5 rounded-3 py-3 px-2">
            انتقاد و پیشنهاد
          </div>
        </div>


        <p class="font-5 font-bold text-end p-body my-5">
          مشکل خود را شرح دهید
        </p>


        <textarea v-model="data.caption"
                  class="textarea_comment_user shadow-KhA bg-white rounded-4 border-costom w-100 p-3 font-5 text-center"
                  placeholder="توضیحات مورد نظر خود را وارد نمایید"></textarea>
        <br>
        <br>

        <div class="w-100 d-flex justify-content-center">
          <button @click="send_ticket"
                  class="bg-color-liner h-75 p-3 rounded-3 font-4 border-0 text-white border-costom w-90 ">
            ارسال تیکت
          </button>
        </div>

        <br>

        <div class="w-100 d-flex justify-content-center">
          <router-link :to="{name:'MyTickets'}" class="text-black font-4">
            تیکت های من
          </router-link>
        </div>

        <br>
        <br>
        <br>

        <!--        <div class="call_support ">-->
        <!--          <div @click="call_support" class="text-decoration-none">-->
        <!--            <img style="width: 100px; height: 100px" src="../assets/img/call_support.svg" alt="">-->
        <!--            <p class="m-0 font-4 px-2">-->
        <!--              تماس مستقیم-->
        <!--            </p>-->
        <!--          </div>-->
        <!--        </div>-->

      </div>


    </div>
  </div>

</template>

<style scoped>

.text_chat_user {
  height: 40px;
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl;
}

.textarea_comment_user {
  height: 10rem;
}

.shadow-KhA {
  box-shadow: 0px 8px 18px rgba(189, 215, 234, 0.6);
}

</style>